// Cognito is retained during the first Cloudflare migration phase so existing
// users can keep their passwords, social logins, and custom:id mappings.
const authConfig = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_9HoW1VTDf',
  aws_user_pools_web_client_id: '2p8kkg3oopvvqa418l5tcbdj11',
  oauth: {
    domain: 'auth.commit2act.org',
    scope: [
      'phone',
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin',
    ],
    redirectSignIn:
      'http://localhost:3000/,https://app.commit2act.org/,https://cloudflare-migration.commit2act.pages.dev/,https://commit2act.pages.dev/',
    redirectSignOut:
      'http://localhost:3000/,https://app.commit2act.org/,https://cloudflare-migration.commit2act.pages.dev/,https://commit2act.pages.dev/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['GOOGLE', 'FACEBOOK'],
  aws_cognito_signup_attributes: ['NAME', 'PREFERRED_USERNAME'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: '8',
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};

export default authConfig;
